import mapDefaultIcon from "../../assets/icons/map/ic_map_default.png"
import mapDefaultWarningIcon from "../../assets/icons/map/ic_map_default_warning.png"
import mapDeliveryIcon from "../../assets/icons/map/ic_map_delivery.png"
import mapPickUpIcon from "../../assets/icons/map/ic_map_pick_up.png"
import mapWarningIcon from "../../assets/icons/map/ic_map_warning.png"
import mapObserveCourierIcon from "../../assets/icons/map/ic_map_observe_courier.png"
import {
    COLOR_PRIMARY_ACTIVE,
    COLOR_SECONDARY_ACTIVE,
    COLOR_SUCCESS_ACTIVE,
    COLOR_WARNING_ACTIVE,
    ColorStatusType,
    STATUS_ERROR,
    STATUS_SUCCESS,
    STATUS_WARNING
} from "./Colors"
import {COURIERS_TEXT, LOGISTICS_TEXT} from "./Texts"
import {OrderStatus} from "../../types/order/OrderDTO"
import {CourierStatus} from "./Courier";

export const PERMISSION_ADMIN = "dispatch.admin"
export const MAX_HEIGHT = 88
export const HEADER_HEIGHT = 4
export const MAX_WIDTH = 22
export const MIN_WIDTH = 8
export const ORDER_ITEM_HEIGHT = 6
export const ORDER_ITEM_MAX_HEIGHT_COUNT = 12

export const FILTER_AVAILABLE_STATUSES: OrderStatus[] = ["CookingStarted", "CookingCompleted"]
export const FILTER_ON_WAY_STATUSES: OrderStatus[] = ["OnWay", "OnWayNow", "Checked"]
export const FILTER_DELAYED_STATUSES: OrderStatus[] = ["Delayed"]
export const toVH = (amount: number) => amount + "vh"
export const toVW = (amount: number) => amount + "vw"

export type FAQType = {
    key: number,
    mainTitle?: string,
    children: {
        id: number,
        color?: ColorStatusType,
        icon?: string,
        description: {
            title?: string,
            items?: {
                text: string,
                color?: string,
                backgroundColor?: string
            }[]
        }
    }[]
}

export const FAQ: FAQType[] = [
    {
        key: 1,
        mainTitle: "Цветовая маркировка зон:",
        children: [
            {
                id: 1,
                color: {
                    value: STATUS_SUCCESS.value,
                    opacity: 1
                },
                description: {
                    title: "Все в штатном режиме - все операции и процессы работают нормально."
                }
            },
            {
                id: 2,
                color: {
                    value: STATUS_WARNING.value,
                    opacity: 1
                },
                description: {
                    title: "Доставка осуществляется с ближайшего филиала - для доставки используйте ближайший к вам филиал."
                }
            },
            {
                id: 3,
                color: {
                    value: STATUS_ERROR.value,
                    opacity: 1
                },
                description: {
                    title: "На этой зоне доставка не принимается - на данной территории не осуществляется доставка."
                }
            }
        ]
    },
    {
        key: 2,
        mainTitle: "Индикация иконок:",
        children: [
            {
                id: 4,
                icon: mapDefaultIcon,
                description: {
                    items: [
                        {
                            text: "✅ - Доставка",
                            color: "rgba(50, 213, 131, 1)",
                            backgroundColor: "rgba(50, 213, 131, .5)"
                        },
                        {
                            text: "✅ - Самовывоз",
                            color: "rgba(50, 213, 131, 1)",
                            backgroundColor: "rgba(50, 213, 131, .5)"
                        }
                    ]
                }
            },
            {
                id: 5,
                icon: mapDeliveryIcon,
                description: {
                    items: [
                        {
                            text: "✅ - Доставка",
                            color: "rgba(50, 213, 131, 1)",
                            backgroundColor: "rgba(50, 213, 131, .5)"
                        },
                        {
                            text: "❌ - Самовывоз",
                            color: "rgba(249, 112, 102, 1)",
                            backgroundColor: "rgba(249, 112, 102, .5)"
                        }
                    ]
                }
            },
            {
                id: 6,
                icon: mapPickUpIcon,
                description: {
                    items: [
                        {
                            text: "❌ - Доставка",
                            color: "rgba(249, 112, 102, 1)",
                            backgroundColor: "rgba(249, 112, 102, .5)"
                        },
                        {
                            text: "✅ - Самовывоз",
                            color: "rgba(50, 213, 131, 1)",
                            backgroundColor: "rgba(50, 213, 131, .5)"
                        }
                    ]
                }
            },
            {
                id: 7,
                icon: mapDefaultWarningIcon,
                description: {
                    items: [
                        {
                            text: "✅ - Доставка, с ближайшего филиала",
                            color: "rgba(50, 213, 131, 1)",
                            backgroundColor: "rgba(50, 213, 131, .5)"
                        },
                        {
                            text: "✅/❌ - Самовывоз",
                            color: "rgba(253, 176, 34, 1)",
                            backgroundColor: "rgba(253, 176, 34, .5)"
                        }
                    ]
                }
            },
            {
                id: 8,
                icon: mapWarningIcon,
                description: {
                    items: [
                        {
                            text: "❌ - Доставка",
                            color: "rgba(249, 112, 102, 1)",
                            backgroundColor: "rgba(249, 112, 102, .5)"
                        },
                        {
                            text: "❌ - Самовывоз",
                            color: "rgba(249, 112, 102, 1)",
                            backgroundColor: "rgba(249, 112, 102, .5)"
                        }
                    ]
                }
            }
        ]
    },
    {
        key: 3,
        children: [
            {
                id: 9,
                icon: mapObserveCourierIcon,
                description: {
                    title: "При клике на информационную плашку о курьере, значок автоматически меняется на иконку отслеживания."
                }
            }
        ]
    },
    {
        key: 4,
        mainTitle: "Статусы заказов:",
        children: [
            {
                id: 10,
                color: {
                    value: COLOR_SECONDARY_ACTIVE,
                    opacity: 1
                },
                description: {
                    title: "В ожидание приготовления"
                }
            },
            {
                id: 11,
                color: {
                    value: COLOR_WARNING_ACTIVE,
                    opacity: 1
                },
                description: {
                    title: "Готовится"
                }
            },
            {
                id: 12,
                color: {
                    value: COLOR_SUCCESS_ACTIVE,
                    opacity: 1
                },
                description: {
                    title: "Приготовлен"
                }
            },
            {
                id: 13,
                color: {
                    value: COLOR_PRIMARY_ACTIVE,
                    opacity: 1
                },
                description: {
                    title: "В пути"
                }
            }
        ]
    }
]

export type FilterType = CourierStatus | "insideAvailable" | "insideAssigned" | "delayed"
export const PAGE_LOGISTICS = 0
export const PAGE_COURIERS = 1

type PageType = {
    id: number,
    title: string
}
export const PAGES: PageType[] = [
    {
        id: PAGE_LOGISTICS,
        title: LOGISTICS_TEXT
    },
    {
        id: PAGE_COURIERS,
        title: COURIERS_TEXT
    }
]